import { Line } from "@sportactics/board-editing";

import { LineModel } from "./line-model";

export function convertLineToModel(line: Line): LineModel {
  return {
    id: line.id,
    start: line.start,
    end: line.end,
    color: line.color,
    width: line.width,
    style: line.style,
  };
}
